'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = _interopRequireDefault(require("cleave.js/react"));
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));
var _Input = _interopRequireDefault(require("@material-ui/core/Input"));
var _groupingString = _interopRequireDefault(require("Components/Forms/Functions/groupingString"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let app = window.app;
class TextInput extends _react.Component {
  state = {
    id: ++app.form_index
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (typeof props.onChange !== 'function') return;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: props['default-value'] || '',
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = e => {
    const component = this,
      props = this.props,
      state = this.state;
    let value = e.target.value;
    if (props.onChange) {
      props.onChange({
        e: e,
        value: value,
        name: props.name
      });
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let status = props.status[props.name];
    const error_msg = status?.error ? /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, status.error) : undefined;
    const prefix = props.prefix ? /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "start"
    }, props.prefix) : undefined;
    const suffix = props.suffix ? /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, props.suffix) : undefined;
    const text_field_component = props.input_format && props.onChange ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, props.label), /*#__PURE__*/_react.default.createElement(_react2.default, {
      id: String(state.id),
      options: props.input_format,
      onChange: component.handleChange,
      name: props.name,
      value: props.value || '',
      className: "cleave_textinput"
    })) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
      htmlFor: String(state.id)
    }, props.label), /*#__PURE__*/_react.default.createElement(_Input.default, {
      id: String(state.id),
      className: props['read-only'] ? 'read-only_textinput' : '',
      onChange: component.handleChange,
      value: props.input_format?.blocks ? (0, _groupingString.default)(props.value, props.input_format.blocks) : props.value || '',
      disabled: props['read-only'] === true,
      name: props.name,
      type: props.type,
      required: props.required || false,
      multiline: props.multiline,
      rows: props.rows,
      autoComplete: props.autoComplete,
      startAdornment: prefix,
      endAdornment: suffix
    }));
    var output = /*#__PURE__*/_react.default.createElement("div", {
      className: props.className || (props.full_width ? 'u-full-width' : '')
    }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
      fullWidth: props.full_width === false ? false : true,
      error: status && status.error ? true : false,
      style: {
        fontFamily: 'inherit'
      }
    }, text_field_component, error_msg));
    return output;
  }
}
exports.default = TextInput;
TextInput.propTypes = {
  onChange: _propTypes.default.func,
  className: _propTypes.default.string,
  full_width: _propTypes.default.bool,
  label: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.string,
  type: _propTypes.default.string,
  input_format: _propTypes.default.object,
  multiline: _propTypes.default.bool,
  rows: _propTypes.default.string,
  status: _propTypes.default.object
};
TextInput.defaultProps = {
  full_width: true,
  type: 'text',
  multiline: false,
  rows: "1",
  status: {}
};
